export const BUY_PRODUCT_REQUEST = 'devices/BUY_PRODUCT_REQUEST'
export const BUY_PRODUCT_SUCCESS = 'devices/BUY_PRODUCT_SUCCESS'
export const BUY_PRODUCT_FAILURE = 'devices/BUY_PRODUCT_FAILURE'
